import { useState, useEffect } from 'react';
import { useDataFetch } from '../../../hooks/use-data-fetch';

export interface Category {
  id: string;
  name: string;
  description: string;
  status: boolean;
}

export const useCategories = () => {
  const [categories, setCategories] = useState<Category[]>([]);
  const { getData } = useDataFetch();
  
  // Fetch categories
  const { data: categoriesData, isLoading } = getData(
    ['categories'],
    '/product/all/categories'
  );
  
  // Update categories state when data changes
  useEffect(() => {
    if (categoriesData?.data?.categories) {
      setCategories(categoriesData.data.categories);
    }
  }, [categoriesData]);

  return {
    categories,
    isLoading
  };
};
